import { styled } from "styled-components";
const MessageImpl = styled.div(
  ({ theme }) => ({
    color: theme.color.gray7,
    fontFamily: theme.fontFamily.default,
    fontSize: theme.fontSize.default,
    lineHeight: theme.lineHeight.default
  }),
  ({ theme, $tone }) => ({
    critical: {
      color: theme.color.red6
    }
  })[$tone]
);
export {
  MessageImpl
};
